/* eslint-disable */

import { toast } from "react-toastify";
import { t } from "@/translate/t";

export const PASSWORD_MIN_LENGTH = 8

//Validate password according rules
const validatePassword = (password: string, passwordRepeat: string): boolean => {
  const passwordRegex = /[!@#$%^&*()\-_=+{}[\]:;"'<>,.?/~]/;
  if (password.length === 0){
    toast(t("self_password_not_defined"), { type : "error"} )
    return false
  } else if (password !== passwordRepeat){
    toast(t("self_password_not_match"), { type : "error"} )
    return false
  } else if (password.length < PASSWORD_MIN_LENGTH){
    toast(t("self_password_too_short", { count : PASSWORD_MIN_LENGTH }), { type : "error"} )
    return false
  } else if (!passwordRegex.test(password)){
    toast(t("self_password_special_character"), { type : "error"} )
    return false
  } else{
    return true
  }
}

export default validatePassword